<template>
	<brows-layout @edit="$emit('edit')" @next="$emit('next')" :userEdit="!isTeamAccount">
		<el-form label-position="left" label-width="100px">
			<el-form-item label="故事帳號">{{editStoryData.account}}</el-form-item>
			<el-form-item label="組別密碼">{{editStoryData.password}}</el-form-item>
			<el-form-item label="小組名稱">{{editStoryData.team_name}}</el-form-item>
			<el-form-item label="小組成員">
				<div class="row" gutter="30" v-for="(member,i) in editStoryData.team_members" :key="i">
					<el-form-item class="name-label">
						{{member.name}}
					</el-form-item>
					<el-form-item>{{member.age}}
						<span class="member-label">歲</span>
					</el-form-item>
					<el-form-item>{{is18 ? member.department : member.grade}}
						<span v-if="!is18" class="member-label">年級</span>
					</el-form-item>
				</div>
			</el-form-item>
			<el-form-item :label="is18?'代表人':'輔導員'">
				<el-form-item v-for="(counselor, i) in editStoryData.counselors" :key="i">{{counselor.name}}&emsp;{{counselor.phone}}&emsp;{{counselor.email}}</el-form-item>
			</el-form-item>
		</el-form>
	</brows-layout>
</template>

<script>
import BrowsLayout from "./BrowsLayout.vue";
import { mapState } from "vuex";

export default {
	components: { BrowsLayout },
	props: ["editStoryData", "is18"],
	data() {
		return {};
	},
	computed: {
		...mapState("user", ["userInfo"]),
		isTeamAccount() {
			return this.userInfo.role == "visitor";
		}
	}
};
</script>

<style lang="scss" scoped>
.name-label {
	min-width: 50px;
}
.member-label {
	margin-left: 5px;
	color: #626468;
}
</style>
